export function numericTextSort<T>(items: T[], textSelector: (item: T) => string, initialOrder?: (item1: T, item2: T) => number): T[] {

    var sortableItems = parseItems(items, textSelector);

    //console.log("NumericTextSort", sortableItems);

    sortableItems.sort((i1, i2) => {

        let d: number;

        if (initialOrder) {
            d = initialOrder(i1.item, i2.item);
        }

        if (!d) {
            d = i1.numericPrefix - i2.numericPrefix;
        }

        //if (d) {
        //    console.log("prefix diff", d, i1, i2);
        //}

        if (!d) {
            d = i1.text.localeCompare(i2.text);
            //if (d) console.log("text diff", d, i1, i2);
        }

        if (!d) {
            d = i1.numericSuffix - i2.numericSuffix;
        }

        return d;

    });

    return sortableItems.map(i => i.item);

}

/**
 * A compare function which sorts `null` or `undefined` items before any non-`null` or non-`undefined` items.
 * @returns A negative value if the first argument is `null` or `undefined`, `undefined` if they're both non-`null` and non-`undefined`, and a positive value otherwise.
 */
export function nullOrUndefinedFirstCompareFn(a: any, b: any): (-1 | undefined | 1) {
    const is = (x: any) => x === null || x === undefined;
    return is(a) && !is(b) ? 1 : is(b) && !is(a) ? -1 : undefined;
}

function parseItems<T>(items: T[], textSelector: (item: T) => string): { item: T, text: string, numericPrefix: number, numericSuffix: number }[] {

    var prefix = new RegExp("^(\\d+)(.*)$");
    var suffix = new RegExp("^(.*?)(\\d+)$");

    var sortableItems = items.map(i => {

        var text = (textSelector(i)?.toString() || "").trim();
        var numericPrefix = null;
        var numericSuffix = null;

        var match = text.match(prefix);

        if (match) {
            numericPrefix = parseInt(match[1]);
            text = match[2];
        }

        match = text.match(suffix);

        if (match) {
            numericSuffix = parseInt(match[2]);
            text = match[1];
        }

        return {

            item: i,
            text: text,
            numericPrefix: numericPrefix,
            numericSuffix: numericSuffix,

        }

    });

    return sortableItems;

}
